module.exports = __webpack_public_path__ + "img/arquam hashim.a2616b05.jpg";